import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-secondary-100/50 border-t border-secondary-200/50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-file-list-3-line text-lg"></i>
              </div>
              <span className="font-heading text-lg font-semibold text-foreground-900 whitespace-nowrap">
                PandabuySheet Hub
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-xs">
              The most advanced curated discovery platform for finding the best products through verified Pandabuy Spreadsheet lists.
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">
              Quick Links
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                Home
              </Link>
              <a href="#categories" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                Categories
              </a>
              <a href="#featured" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                Featured Spreadsheets
              </a>
              <Link to="/blog/pandabuy-spreadsheet-guide" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                Pandabuy Spreadsheet Guide
              </Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">
              Top Categories
            </h4>
            <div className="grid grid-cols-2 gap-2">
              {categories.slice(0, 8).map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-200/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            {t("footer.copyright")}
          </p>
          <p className="text-xs text-foreground-400 max-w-md text-center sm:text-right">
            {t("footer.disclaimer")}
          </p>
        </div>
      </div>
    </footer>
  );
}